import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import * as moment from 'moment';

function DateRangePicker({ start, end, onChange, errorMessage, setErrorMessage }) {
  const [startDate, setStartDate] = useState(start ? new Date(start) : null);
  const [endDate, setEndDate] = useState(end ? new Date(end) : null);
  const [minDate, setMinDate] = useState(null);

  useEffect(() => {
    if (start) setStartDate(new Date(start));
    if (end) setEndDate(new Date(end));
  }, [start, end]);

  const handleStartDateChange = (date) => {
    const newStartDate = moment(date).format('YYYY-MM-DDThh:mm:ssZ');
    setStartDate(date);
    onChange(newStartDate, null);
    setMinDate(date); 

    if (!end) {
      setErrorMessage("End date is required");
    } else {
      setErrorMessage(null);
    }
  };

  const handleEndDateChange = (date) => {
    const newEndDate = moment(date).format('YYYY-MM-DDThh:mm:ssZ');

    if (!start) {
      setErrorMessage("Start date is required");
    } else {
      setEndDate(date);
      onChange(start, newEndDate);
      setErrorMessage(null);
    }
  };

  const handleStartDateKeyDown = (event) => {
    if (event.key === "Backspace" || event.key === "Delete") {
      setStartDate(null);
      onChange(null, endDate);
      setMinDate(null);
      setErrorMessage("Start date is required");
    }
  };

  const handleEndDateKeyDown = (event) => {
    if (event.key === "Backspace" || event.key === "Delete") {
      setEndDate(null);
      onChange(startDate, null);
    }
  };

  return (
    <div>
      <label htmlFor="start-date">Start date:</label>
      <DatePicker
        selected={startDate}
        onChange={handleStartDateChange}
        onKeyDown={handleStartDateKeyDown}
        dateFormat="MM/dd/yyyy"
      />
      <br />
      <label htmlFor="end-date">End date:</label>
      <DatePicker
        selected={endDate}
        onChange={handleEndDateChange}
        onKeyDown={handleEndDateKeyDown}
        minDate={minDate} 
        dateFormat="MM/dd/yyyy"
        openToDate={startDate} 
      />
      <p className="text-primary-100 bold">{errorMessage}</p>
    </div>
  );
}

export default DateRangePicker;
